import JdsSpinner from './Spinner.vue';
export { JdsSpinner };
export default JdsSpinner;